var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C7 4.44772 7.44772 4 8 4H17.1707C17.0602 4.31278 17 4.64936 17 5V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V18C15 17.4477 14.5523 17 14 17H7V5ZM19 5C19 4.44772 19.4477 4 20 4C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6C19.4477 6 19 5.55228 19 5ZM20 8C19.6494 8 19.3128 7.93985 19 7.82929V20C19 21.6569 17.6569 23 16 23H4C2.34315 23 1 21.6569 1 20V18C1 17.4477 1.44772 17 2 17H5V5C5 3.34315 6.34315 2 8 2H20C21.6569 2 23 3.34315 23 5C23 6.65685 21.6569 8 20 8ZM13 20C13 20.3506 13.0602 20.6872 13.1707 21H4C3.44772 21 3 20.5523 3 20V19H13V20ZM15 6H8V7H15V6ZM8 8H16V9H8V8ZM14 10H8V11H14V10ZM8 12H15V13H8V12ZM12 14H8V15H12V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/Scroll.1223c8ac3533f004a78bdf27f2ecced1.svg";
export { ForwardRef as ReactComponent };